export default __webpack_public_path__ + "logo-horizontal-a01dd65dc0d6c829453929ec4905a7e4.svg";